import { WarningOutlined } from '@ant-design/icons';
import { Modal, ModalProps, Typography } from 'antd';

const ActiveCandidatesWarningModal = ({ ...props }: ModalProps) => {
  return (
    <Modal
      title={
        <Typography.Text strong>
          <WarningOutlined /> Atenção! Esta vaga será concluída automaticamente
        </Typography.Text>
      }
      okText="Continuar"
      okButtonProps={{ danger: true }}
      cancelText="Retornar e enviar feedback"
      {...props}
    >
      <Typography.Paragraph>
        Ao realizar esta movimentação, você preencherá todas as posições e esta vaga será{' '}
        <Typography.Text strong>concluída automaticamente</Typography.Text>.
      </Typography.Paragraph>
      <Typography.Paragraph>
        Antes de confirmar essa ação, lembre-se que após uma vaga ser concluída, não será mais
        possível <Typography.Text strong>Reprovar</Typography.Text> candidatos. Se ainda houver
        candidatos ativos no processo, recomendamos que realize a ação de{' '}
        <Typography.Text strong>Reprovar</Typography.Text>, enviando email de feedback, e então
        conclua a vaga movendo os candidatos selecionados para a etapa{' '}
        <Typography.Text strong>Contratados</Typography.Text> novamente.
      </Typography.Paragraph>
    </Modal>
  );
};

export default ActiveCandidatesWarningModal;
